import { useContext } from "react";
import Context from "./Context";
export { default as withToast } from "./with.js";
export { default } from "./Provider.js";

export function useToast() {
  return useContext(Context);
}
